export default __webpack_public_path__ + "static/media/sv5_en_rudl_a2.41ea8b22.mp3";